import { Button, useMediaQuery, useTheme } from '@mui/material';
import { useContext } from 'react';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { makeStyles } from 'tss-react/mui';
import AddIcon from '@mui/icons-material/AddCircleOutlineOutlined';
import { type ITheme } from '../../../theme';
import { AppConstantsContext } from '../../../context';
import { JobType } from '../../../entities';

const useStyles = makeStyles()((theme: ITheme) => ({
  container: {
    height: '100%',
    display: 'flex',
    [theme.breakpoints.down('md')]: {
      justifyContent: 'center',
      height: '3em',
      background: theme.palette.primary.main,
      borderRadius: 0,
      width: '100%',
      position: 'fixed',
      bottom: 0,
      left: 0,
      right: 0,
    },
  },
  buttonMobile: {
    boxShadow: 'none',
    borderRadius: '50%',
  },
  button: {
    position: 'relative',
    overflow: 'hidden',
    backgroundImage: `linear-gradient(to right, ${theme.palette.primary.main}, #8a076e)`,
    height: '100%',
    display: 'flex',
    borderRadius: 12,
    fontSize: '1.8rem',
    fontWeight: 600,
    padding: '0.5rem 1rem',
    color: '#fff',
    width: '100%',
    transition: 'all 0.3s ease',
    boxShadow: 'none', // do not use border, it causes bumpy animation

    '&:hover': {
      filter: 'brightness(1.2)',
      boxShadow: `
        0 0 0 2px white,                  /* simulates border */
        0 0 12px 2px rgba(255, 255, 255, 0.6) /* glow */
      `,
    },
    [theme.breakpoints.down('md')]: {
      fontSize: '1.4rem',
      padding: '0.5rem 1rem',
    },
  },
}));

export interface InputButtonProps {
  openDialog: () => void;
}

const InputButton: React.FC<InputButtonProps> = ({ openDialog }) => {
  const { classes } = useStyles();
  const theme = useTheme();
  const { t } = useTranslation();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const { jobType } = useContext(AppConstantsContext);

  return (
    <div className={classes.container}>
      {!isMobile && (
        <Button
          variant="contained"
          startIcon={<AddIcon style={{ fontSize: '3.5rem' }} />}
          onClick={openDialog}
          id="btn_songbook_create_new"
          className={classes.button}
        >
          {jobType === JobType.TranscribeScan
            ? t('home.songbook.input_button_scan')
            : t('home.songbook.input_button')}
        </Button>
      )}
      {isMobile && (
        <Button onClick={openDialog} className={classes.buttonMobile}>
          <AddIcon
            style={{
              fontSize: '3.2rem',
              color: '#fff',
              background: theme.palette.primary.main,
              marginBottom: '15px',
              borderRadius: '50% 50% 0 0',
              border: `3px solid ${theme.palette.primary.main}`,
            }}
          />
        </Button>
      )}
    </div>
  );
};

export default InputButton;
